export default __webpack_public_path__ + "static/media/consorcioLogo.42d2b451.svg";